import siteMetadata from '@/data/siteMetadata';

const headerNavLinks = [
  { href: '/', title: 'Home' },
  { href: '/blog', title: 'Blog' },
  { href: siteMetadata.docsUrl, title: 'Docs', external: true },
  { href: '/about', title: 'About' },
  { href: '/careers', title: 'Careers' },
  // { href: siteMetadata.portalUrl, title: 'Portal', external: true },
  { href: '/contact', title: 'Contact' },
];

export default headerNavLinks;
